
import React from 'react';
import { Button } from "@/components/ui/button";
import { SaveIcon } from "lucide-react";

interface CampSaveButtonProps {
  saving?: boolean;
  className?: string;
  onClick?: () => void;
  type?: "button" | "submit";
  form?: string;
  isDirty?: boolean;
  isWelcomeScreen?: boolean;
}

export const CampSaveButton = ({ 
  saving, 
  className, 
  onClick, 
  type = "submit",
  form,
  isDirty,
  isWelcomeScreen = false
}: CampSaveButtonProps) => {
  console.log("Rendering CampSaveButton, saving:", saving, "type:", type, "form:", form, "isDirty:", isDirty, "isWelcomeScreen:", isWelcomeScreen);
  
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    console.log("Save button clicked in CampSaveButton component");
    if (onClick) {
      e.preventDefault(); // Prevent form submission if it's in a form
      onClick();
    }
  };
  
  return (
    <Button 
      type={type}
      disabled={saving}
      variant="default" // Always use default variant to make button prominent
      className={`save-draft-button flex items-center gap-2 ${className || ''}`}
      onClick={handleClick}
      form={form}
      data-testid="save-draft-button"
    >
      <SaveIcon className="w-4 h-4" />
      {isWelcomeScreen ? "Save" : "Save draft"}
    </Button>
  );
};
